// extracted by mini-css-extract-plugin
export default {"generic":"style_generic__gXkrm","reflex":"style_reflex__qrrMJ"};